$(function () {
    var $modal = $('.ntc-modal');
    var $text = $('.ntc-modal_text');
    var $alert = $('.ntc-modal_text-alert');
    var $phone = $('.ntc-modal_phone');
    var $email = $('.ntc-modal_email');
    var $url = $('.ntc-modal input[name=badurl]');
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    var maxLen = parseInt($text.attr('maxlength'), 10);

    if (isMobile) {
        $modal.addClass('ntc-modal--mobile');
        $('.ntc-modal_btn-close').html('Закрыть');
    }

    $(document).on('opened', '.ntc-modal', function (e) {
        $url.val('//' + location.host + location.pathname);
    });

    $(document).on('closed', '.ntc-modal', function (e) {
        showForm();
    });

    $text.keydown(function(e) {
        if ($text.val().length >= maxLen && e.key.length === 1) {
            showAlert('Вы ввели максимальное допустимое количество символов');
            return false;
        } else {
            hideAlert();
        }
    });

    $('.ntc-modal_form form').submit(function (e) {
        e.preventDefault();
        if (!validate()) return;
        $.ajax({
            url: '//notice.ykt.ru/',
            data: {
                notice: 'global',
                badurl: $url.val(),
                post: $text.val(),
                cotnacts: ($phone.val() ? $phone.val() + ' ' : '') + ($email.val() ? $email.val() : '')
            },
            dataType: 'jsonp',
            success: function () {
                showDone();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                //alert('Ошибка!\n' + textStatus + '\n' + errorThrown);
            }
        });
    });

    $phone.ygmTooltip({position: 'top'});

    $phone.focus(function () {
        if ($phone.val() === '') {
            $phone.val('+7');
        }
    });

    $phone.focusout(function () {
        if ($phone.val() === '+7') {
            $phone.val('');
        }
    });

    function showForm() {
        $modal.removeClass('ntc-modal--done');
        $modal.find('.remodal-close').show();
        $('.ntc-modal_done').hide();
        $('.ntc-modal_form').show();
    }

    function showDone() {
        $text.val('');
        $phone.val('');
        $email.val('');
        $modal.addClass('ntc-modal--done');
        $modal.find('.remodal-close').hide();
        $('.ntc-modal_form').hide();
        $('.ntc-modal_done').show();
    }

    function validate() {
        if ($text.val().trim() === '') {
            showAlert('Пожалуйста, заполните это поле');
            return false;
        }
        return true;
    }

    function showAlert(text) {
        $alert.html(text).show();
        $text.addClass('ntc-modal_input--alert').focus();
    }

    function hideAlert() {
        $alert.html('').hide();
        $text.removeClass('ntc-modal_input--alert');
    }
});
